"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialsFormToJSON = exports.CredentialsFormFromJSONTyped = exports.CredentialsFormFromJSON = void 0;
function CredentialsFormFromJSON(json) {
    return CredentialsFormFromJSONTyped(json, false);
}
exports.CredentialsFormFromJSON = CredentialsFormFromJSON;
function CredentialsFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'username': json['username'],
        'password': json['password'],
    };
}
exports.CredentialsFormFromJSONTyped = CredentialsFormFromJSONTyped;
function CredentialsFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'username': value.username,
        'password': value.password,
    };
}
exports.CredentialsFormToJSON = CredentialsFormToJSON;
//# sourceMappingURL=CredentialsForm.js.map